export const CREDENTIAL_FORM_ID = 'integration_credential_form';
